import { AxiosInstance } from 'axios';
import { ErrorProtocol } from './error.types';

/**
 * API method to persist occured errors
 * @param axios instance of axios
 * @param error to save on the db
 * @returns Boolean depending on success
 */
export const persistError = async (
  axios: AxiosInstance,
  error: ErrorProtocol,
): Promise<boolean> => {
  return axios
    .post('/error/', error)
    .then((res) => res.status === 201)
    .catch((exc) => {
      console.error('Error while saving error', exc);
      return false;
    });
};
